import gql from 'graphql-tag'

const GET_MAILINGS = gql`
  query getMailings($campanhaId: Int!) {
    mailings(campanhaId: $campanhaId){
      id
      descricao
      ativo
      recebeuRevista
    }
  }
`

export {
  GET_MAILINGS
}



// WEBPACK FOOTER //
// ./src/graphql/mailings.graphql.js